<div [ngClass]="{ 'preview-mode': previewMode }" class="title-bar">
  <mat-toolbar color="primary">
    <div class="left">
      <span (click)="openUTInfoDialog()" class="product clickable-product">
        {{ 'twenteIlsPlayer' | translate }}
      </span>
      <div class="title">{{ title }}</div>
    </div>
    <div class="right">
      @if (previewMode) {
        <div [matTooltip]="'login.published.warning' | translate" class="preview-indicator">
          <mat-icon>warning_amber</mat-icon>
          <span>{{ 'ilsPlayer.previewMode' | translate }}</span>
        </div>
      }
      @if (published) {
        <div
          (click)="duplicateIls()"
          [matTooltip]="'ilsPlayer.duplicateTooltip' | translate"
          class="duplicate-ils"
        >
          <mat-icon>add</mat-icon>
          <span>{{ 'ilsPlayer.duplicate' | translate }}</span>
        </div>
      }
      @if (hasCollaborationGroup()) {
        <div class="group-members">
          <div class="group-members-icon">
            <mat-icon>groups</mat-icon>
          </div>
          <div class="group-members-text">
            <span class="group-members-label">{{ 'ilsPlayer.studentGroup.toolbarLabel' | translate }}</span>
            <span class="group-member-names">
              @for (member of groupMembers(); track member._id) {
                <span class="group-member" [class.current-user]="member.isCurrentUser">
                  <span class="group-member-name">{{ member.nickname }}</span>
                </span>
              }
            </span>
          </div>
        </div>
      }
      @if (nickname) {
        <div
          (click)="logout()"
          [matTooltip]="'ilsPlayer.logout' | translate"
          [attr.aria-label]="'ilsPlayer.logout' | translate"
          class="logout"
          [class.icon-only]="hasCollaborationGroup()"
        >
          @if (!hasCollaborationGroup()) {
            <span class="nickname">{{ nickname }} </span>
          }
          <mat-icon>logout</mat-icon>
        </div>
      }
      <lib-contact-golab></lib-contact-golab>
    </div>
  </mat-toolbar>
</div>
